<template>
  <section class="sticky top-0 bg-white z-50 shadow-lg">
    <div class="w-full overflow-hidden">
      <div class="scroll-text hidden lg:block text-black">
        Precautions to be taken by the students before enrolling in programmes
        offered under Open & Distance Learning (ODL) and/or Online Learning mode
        -
        <a href="https://api.onlineyenepoya.com/media/brochure/UGC_20240319152222_1.pdf" target="blank"
          class="text-[#81C8DC] underline">
          Link
        </a>
      </div>
    </div>

    <div class="w-full mx-auto max-w-7xl flex justify-between">
      <nav class="container px-3 py-4 mx-auto md:flex md:justify-between md:items-center">
        <div class="relative flex items-center justify-between mx-auto">
          <div class="w-[1/2] flex items-center gap-5">
            <a href="/">
              <img src="../assets/logo.webp" class="sm:hidden hidden w-[250px] lg:block" alt />
              <img src="../assets/logo.webp" class="w-[10rem] sm:block lg:hidden" alt />
            </a>

            <div class="flex gap-2 items-center bg-[#81C8DC] lg:px-2 p-1 sm:text-sm rounded-2xl sm:p-2">
              <button @click="isDropdownOpen = !isDropdownOpen" id="mega-menu-icons-dropdown-button"
                data-dropdown-toggle="mega-menu-icons-dropdown"
                class="flex items-center justify-between px-2 lg:text-lg text-[14px] font-semibold text-white bg-[#81C8DC] rounded-xl">
                Programs
                <svg aria-hidden="true" class="w-5 h-5 ml-1" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd" />
                </svg>
              </button>
              <div id="mega-menu-icons-dropdown"
                class=" navi fixed w-screen inset-0 z-50 lg:!top-[27px] hidden flex flex-col lg:flex-row bg-white rounded-b-xl drop-shadow-2xl">
                <!-- Mobile View -->
                <div class="lg:hidden w-full flex flex-col mt-[20px]">
                  <!-- Tabs for Mobile -->
                  <div class="flex border-b border-gray-200">
                    <button @click="activeSection = 'masters'"
                      class="w-1/2 py-4 text-center font-semibold text-lg transition-colors" :class="activeSection === 'masters'
                        ? 'text-white bg-[#94C34D] border-b-2 border-[#94C34D]'
                        : 'text-gray-500 bg-[#e5e7eb]'">
                      Master's Degree
                    </button>
                    <button @click="activeSection = 'bachelors'"
                      class="w-1/2 py-4 text-center font-semibold text-lg transition-colors" :class="activeSection === 'bachelors'
                        ? 'text-white bg-[#94C34D] border-b-2 border-[#94C34D]'
                        : 'text-gray-500 bg-[#e5e7eb]'">
                      Bachelor's Degree
                    </button>
                  </div>

                  <!-- Mobile Content Area -->
                  <div class="overflow-y-auto flex-1 p-4 max-h-[calc(100vh-200px)]">
                    <!-- Masters Section -->
                    <div v-show="activeSection === 'masters'" class="space-y-4">
                      <!-- MBA Accordion -->
                      <div class="border-b pb-2">
                        <button @click="toggleProgram('mba')"
                          class="w-full flex justify-between items-center py-3 text-left font-medium text-[#94C34D]">
                          <span class="text-lg">Master of Business Administration (MBA)</span>
                          <span class="transform transition-transform"
                            :class="openProgram === 'mba' ? 'rotate-90' : ''">▶</span>
                        </button>

                        <div v-show="openProgram === 'mba'" class="py-2 space-y-4 text-left">
                          <a href="/programs/online-mba-marketing" class="block text-black hover:text-[#94C34D]">→ MBA
                            in Marketing</a>
                          <a href="/programs/online-mba-finance" class="block text-black hover:text-[#94C34D]">→ MBA in
                            Finance</a>
                          <a href="/programs/online-mba-human-resource" class="block text-black hover:text-[#94C34D]">→
                            MBA in Human Resource Management</a>
                          
                          <a href="/programs/online-mba-data-science-and-analytics"
                            class="block text-black hover:text-[#94C34D]">→ MBA in Data Science and Analytics</a>
                          <a href="/programs/online-mba-marketing-and-finance"
                            class="block text-black hover:text-[#94C34D]">→ MBA in Marketing and Finance</a>
                          <a href="/programs/online-mba-marketing-and-human-resource"
                            class="block text-black hover:text-[#94C34D]">→ MBA in Marketing and Human Resource
                            Management</a>
                          <a href="/programs/online-mba-finance-and-human-resource"
                            class="block text-black hover:text-[#94C34D]">→ MBA in Human Resource Management and
                            Finance</a>
                          <a href="/programs/online-mba-healthcare-management"
                            class="block text-black hover:text-[#94C34D]">→ MBA in Healthcare Management</a>
                            <a href="/programs/online-mba-international-finance"
                            class="block text-black hover:text-[#94C34D]">→ MBA in International Finance (ACCA)</a>
                          <a href="/programs/online-mba-strategic-accounting-and-taxation"
                            class="block text-black hover:text-[#94C34D]">→ MBA in Strategic Accounting and Taxation</a>
                          <a href="/programs/online-mba-public-administration"
                            class="block text-black hover:text-[#94C34D]">→ MBA in Public Administration</a>
                        </div>
                      </div>

                      <!-- MCA Accordion -->
                      <div class="border-b pb-2">
                        <button @click="toggleProgram('mca')"
                          class="w-full flex justify-between items-center py-3 text-left font-medium text-[#94C34D]">
                          <span class="text-lg">Master of Computer Application (MCA)</span>
                          <span class="transform transition-transform"
                            :class="openProgram === 'mca' ? 'rotate-90' : ''">▶</span>
                        </button>

                        <div v-show="openProgram === 'mca'" class="py-2 space-y-4 text-left">
                          <a href="/programs/online-mca-computer-science-and-it"
                            class="block text-black hover:text-[#94C34D]">→ MCA in Computer Science and Information
                            Technology</a>
                        </div>

                        <div v-show="openProgram === 'mca'" class="py-2 space-y-4 text-left">
                          <a href="/programs/online-mca-cloud-computing-and-cyber-security"
                            class="block text-black hover:text-[#94C34D]">→ MCA in Cloud Computing and Cyber Security
                          </a>
                        </div>
                      </div>
                    </div>

                    <!-- Bachelors Section -->
                    <div v-show="activeSection === 'bachelors'" class="space-y-4">
                      <!-- BCom Accordion -->
                      <div class="border-b pb-2">
                        <button @click="toggleProgram('bcom')"
                          class="w-full flex justify-between items-center py-3 text-left font-medium text-[#94C34D]">
                          <span class="text-lg">Bachelor of Commerce (B.Com)</span>
                          <span class="transform transition-transform"
                            :class="openProgram === 'bcom' ? 'rotate-90' : ''">▶</span>
                        </button>

                        <div v-show="openProgram === 'bcom'" class="py-2 space-y-4 text-left">
                          <!-- <a href="/programs/online-bcom-management-accounting"
                            class="block text-black hover:text-[#94C34D]">→ B.Com in Management Accounting</a>
                          <a href="/programs/online-bcom-corporate-accounting"
                            class="block text-black hover:text-[#94C34D]">→ B.Com in Corporate Accounting</a> -->
                          <a href="/programs/online-bcom-accounting-and-finance"
                            class="block text-black hover:text-[#94C34D]">→ B.Com in Accounting and Finance</a>
                          <!-- <a href="/programs/online-bcom-advanced-finance-and-accounting"
                            class="block text-black hover:text-[#94C34D]">→B.Com in Advanced Finance and Accounting</a> -->
                          <a href="/programs/online-bcom-international-finance-and-accounting"
                            class="block text-black hover:text-[#94C34D]">→ B.Com in International Finance and
                            Accounting (Accredited by ACCA, UK)</a>
                        </div>
                      </div>

                      <!-- BBA Accordion -->
                      <div class="border-b pb-2">
                        <button @click="toggleProgram('bba')" class="w-full py-3 text-left font-medium text-[#94C34D]">
                          <span class="text-lg">Bachelor of Business Administration (BBA)</span>
                          <span class="transform transition-transform"
                            :class="openProgram === 'bba' ? 'rotate-90' : ''">▶</span>
                        </button>

                        <div v-show="openProgram === 'bba'" class="py-2 space-y-4 text-left">
                          <a href="/programs/online-bba-general-management"
                            class="block text-black hover:text-[#94C34D]">→ BBA in General Management</a>
                          <a href="/programs/online-bba-healthcare-management"
                            class="block text-black hover:text-[#94C34D]">→ BBA in Healthcare Management</a>
                          <a href="/programs/online-bba-logistics-and-supply-chain-management"
                            class="block text-black hover:text-[#94C34D]">→ BBA in Logistics and Supply Chain
                            Management</a>
                        </div>
                      </div>

                      <!-- BCA Accordion -->
                      <div class="border-b pb-2">
                        <button @click="toggleProgram('bca')"
                          class="w-full flex justify-between items-center py-3 text-left font-medium text-[#94C34D]">
                          <span class="text-lg">Bachelor of Computer Application (BCA)</span>
                          <span class="transform transition-transform"
                            :class="openProgram === 'bca' ? 'rotate-90' : ''">▶</span>
                        </button>

                        <div v-show="openProgram === 'bca'" class="py-2 space-y-4 text-left">
                          <a href="/programs/online-bca-data-science-and-artificial-intelligence"
                            class="block text-black hover:text-[#94C34D]">→ BCA in Data Science and Artificial
                            Intelligence</a>
                          <a href="/programs/online-bca-computer-science-and-it"
                            class="block text-black hover:text-[#94C34D]">→ BCA in Computer Science and IT</a>
                          <a href="/programs/online-bca-cloud-computing-and-cyber-security"
                            class="block text-black hover:text-[#94C34D]">→ BCA in Cloud Computing & Cyber Security</a>
                          <a href="/programs/online-bca-animation-and-graphic-design"
                            class="block text-black hover:text-[#94C34D]">→ BCA in Multimedia and Animation</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- Tablet/Desktop View -->
                <div
                  class="hidden lg:block w-full mx-auto max-w-7xl lg:flex lg:flex-row justify-center h-[700px] overflow-x-hidden">
                  <div class="bg-[#94C34D] w-[40%]">
                    <div class="w-full">
                      <div
                        class="p-4 font-semibold text-white flex gap-2 lg:text-left text-center md:text-center justify-center lg:justify-start items-center text-2xl">
                        <span>Master's Degree</span>
                      </div>

                      <ul class="flex justify-evenly lg:gap-1 gap-3 mb-0 list-none lg:flex-col flex-row">
                        <li class="mb-px w-full mr-2 last:mr-0 lg:flex-col lg:text-left text-center cursor-pointer">
                          <a @click="toggleTabs(1)" class="text-[15px] uppercase px-5 py-3 sm:rounded block transition"
                            :class="[
                              openTab === 1
                                ? 'text-white bg-[#94C34D] font-bold'
                                : 'text-white font-normal hover:font-bold'
                            ]">
                            <span class="mr-2 pb-2">></span>
                            Master of Business Administration (MBA)
                          </a>
                        </li>
                        <li class="mb-px w-full mr-2 last:mr-0 lg:flex-col lg:text-left text-center cursor-pointer">
                          <a @click="toggleTabs(2)" class="text-[15px] uppercase px-5 py-3 sm:rounded block transition"
                            :class="[
                              openTab === 2
                                ? 'text-white bg-[#94C34D] font-bold'
                                : 'text-white font-normal hover:font-bold'
                            ]">
                            <span class="mr-2 pb-2">></span>
                            Master of Computer Application (MCA)
                          </a>
                        </li>
                      </ul>
                      <div
                        class="p-4 font-semibold text-white flex gap-2 lg:text-left text-center md:text-center justify-center lg:justify-start items-center text-2xl">
                        <span class="">Bachelor's Degree</span>
                      </div>

                      <ul class="flex justify-evenly lg:gap-1 gap-3 mb-0 list-none lg:flex-col flex-row">

                        <li class="mb-px w-full mr-2 last:mr-0 lg:flex-col lg:text-left text-center cursor-pointer">
                          <a @click="toggleTabs(3)" class="text-[15px] uppercase px-5 py-3 sm:rounded block transition"
                            :class="[
                              openTab === 3
                                ? 'text-white bg-[#94C34D] font-bold'
                                : 'text-white hover:font-bold font-normal'
                            ]">
                            <span class="mr-2 pb-2">></span>
                            Bachelor of Commerce (B.Com)
                          </a>
                        </li>

                        <li class="mb-px w-full mr-2 last:mr-0 lg:flex-col lg:text-left text-center cursor-pointer">
                          <a @click="toggleTabs(4)" class="text-[15px] uppercase px-5 py-3 sm:rounded block transition"
                            :class="[
                              openTab === 4
                                ? 'text-white bg-[#94C34D] font-bold'
                                : 'text-white hover:font-bold font-normal'
                            ]">
                            <span class="mr-2 pb-2">></span>
                            Bachelor of Business Administration (BBA)
                          </a>
                        </li>

                        <li class="mb-px w-full mr-2 last:mr-0 lg:flex-col lg:text-left text-center cursor-pointer">
                          <a @click="toggleTabs(5)" class="text-[15px] uppercase px-5 py-3 sm:rounded block transition"
                            :class="[
                              openTab === 5
                                ? 'text-white bg-[#94C34D] font-bold'
                                : 'text-white hover:font-bold font-normal'
                            ]">
                            <span class="mr-2 pb-2">></span>
                            Bachelor of Computer Application (BCA)
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="w-[30%] bg-white">
                    <div class="relative flex flex-col w-full">
                      <div class="px-4 py-1 flex-auto">
                        <div class="tab-content tab-space">
                          <div v-bind:class="{
                            hidden: openTab !== 3,
                            block: openTab === 3,
                          }">
                            <div class="">
                              <h1 class="text-[#94C34D] text-2xl font-bold pb-6 text-left">Bachelor's Degree</h1>
                            </div>
                            <ul class="space-y-4 text-left">
                              <!-- <li class=" cursor-pointer">
                                <a href="/programs/online-bcom-management-accounting"
                                  class="flex items-center text-black hover:text-[#94C34D]"> <span
                                    class="mr-2 pb-2">→</span>B.Com in Management Accounting</a>
                              </li> 
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bcom-corporate-accounting"
                                  class="flex items-center text-black hover:text-[#94C34D]"> <span
                                    class="mr-2 pb-2">→</span>B.Com in Corporate Accounting</a>
                              </li>
                              <li class=""></li>-->

                              <li class=" cursor-pointer">
                                <a href="/programs/online-bcom-accounting-and-finance"
                                  class="flex items-center text-black hover:text-[#94C34D]"> <span
                                    class="mr-2 pb-2">→</span>B.Com in Accounting and Finance</a>
                              </li>
                              <!-- <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bcom-advanced-finance-and-accounting"
                                  class="flex items-center text-black hover:text-[#94C34D]"> <span
                                    class="mr-2 pb-2">→</span>B.Com in Advanced Finance and Accounting</a>
                              </li> -->
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bcom-international-finance-and-accounting"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>B.Com in International Finance and Accounting
                                  (Accredited by ACCA, UK)
                                </a>
                              </li>

                            </ul>
                          </div>

                          <!-- Other tab content preserved from original -->
                          <div v-bind:class="{
                            hidden: openTab !== 4,
                            block: openTab === 4,
                          }">
                            <div class="">
                              <h1 class="text-[#94C34D] text-2xl font-bold pb-6 text-left">Bachelor's Degree</h1>
                            </div>
                            <ul class="space-y-4 text-left">
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bba-general-management"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>BBA in General Management
                                </a>
                              </li>
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bba-healthcare-management"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>BBA in Healthcare Management
                                </a>
                              </li>
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bba-logistics-and-supply-chain-management"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span> BBA in Logistics and Supply Chain Management
                                </a>
                              </li>
                            </ul>
                          </div>

                          <!-- Rest of the original tab content preserved... -->
                          <div v-bind:class="{
                            hidden: openTab !== 5,
                            block: openTab === 5,
                          }">
                            <div class="">
                              <h1 class="text-[#94C34D] text-2xl font-bold pb-6 text-left">Bachelor's Degree</h1>
                            </div>
                            <ul class="space-y-4 text-left">
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bca-data-science-and-artificial-intelligence"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>BCA in Data Science and Artificial Intelligence
                                </a>
                              </li>
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bca-computer-science-and-it"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>BCA in Computer Science and IT
                                </a>
                              </li>
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bca-cloud-computing-and-cyber-security"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>BCA in Cloud Computing & Cyber Security
                                </a>
                              </li>
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-bca-animation-and-graphic-design"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>BCA in Multimedia and Animation
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div v-bind:class="{
                            hidden: openTab !== 1,
                            block: openTab === 1,
                          }">
                            <div class="">
                              <h1 class="text-[#94C34D] text-2xl font-bold pb-6 text-left">Master's Degree</h1>
                            </div>
                            <ul class="space-y-4 text-left">
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-marketing"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Marketing
                                </a>
                              </li>
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-finance"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Finance
                                </a>
                              </li>
                              <li class=""></li>

                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-human-resource"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Human Resource Management
                                </a>
                              </li>
               
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-data-science-and-analytics"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Data Science and Analytics
                                </a>
                              </li>
                            

                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-marketing-and-finance"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Marketing and Finance
                                </a>
                              </li>
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-marketing-and-human-resource"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Marketing and Human Resource Management
                                </a>
                              </li>
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-finance-and-human-resource"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Human Resource Management and Finance
                                </a>
                              </li>
                              <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-healthcare-management"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Healthcare Management
                                </a>
                              </li>
                              <li class=""></li>
                         <li class=""></li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-international-finance"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in International Finance (ACCA)
                                </a>
                              </li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-strategic-accounting-and-taxation"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Strategic Accounting and Taxation
                                </a>
                              </li>
                      
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mba-public-administration"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MBA in Public Administration
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div v-bind:class="{
                            hidden: openTab !== 2,
                            block: openTab === 2,
                          }">
                            <div class="">
                              <h1 class="text-[#94C34D] text-2xl font-bold pb-6 text-left">Master's Degree</h1>
                            </div>
                            <ul class="space-y-4 text-left">
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mca-computer-science-and-it"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MCA in Computer Science and Information
                                  Technology
                                </a>
                              </li>
                              <li class=" cursor-pointer">
                                <a href="/programs/online-mca-cloud-computing-and-cyber-security"
                                  class="flex items-center text-black hover:text-[#94C34D]">
                                  <span class="mr-2 pb-2">→</span>MCA in Cloud Computing and Cyber Security
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-[30%]">
                    <img src="@/assets/program_dropdown.png" alt="Program Dropdown"
                      class="w-full h-auto object-contain" />
                  </div>
                </div>

              </div>
            </div>
          </div>
          <!-- <div :class="{'ml-52': isExcludedPage}"> -->
          <div class="w-[1/2] hidden lg:flex sm:hidden items-center ml-80 pl-12 gap-16">
            <div>
              <!-- <p class="text-lg font-semibold text-black p-4 rounded-xl">Enquire Now</p> -->
              <div v-if="!isExcludedPage" @click="enquiryActivate" class="hidden lg:block">
                <button class="block py-2 pl-3 pr-4 font-bold rounded lg:p-0">
                  Enquire Now
                </button>
              </div>
            </div>
            <div v-if="!isExcludedPage">
              <a @click="handleRedirect"
                class="text-lg font-semibold text-white bg-[#81C8DC] p-2 pr-8 pl-8 rounded-xl">Apply Now</a>
            </div>
          </div>
          <!-- Mobile menu button -->
          <div @click="this.showMenu = !this.showMenu" class="flex md:hidden items-center">
            <button type="button" class="text-black-100 hover:text-black-400 focus:outline-none focus:text-black-400">
              <svg viewBox="0 0 24 24" class="w-6 h-6 fill-current">
                <path fill-rule="evenodd"
                  d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
              </svg>
            </button>
          </div>
          <!-- </div> -->
        </div>
        <!-- Mobile Menu open: "block", Menu closed: "hidden" -->
        <ul :class="this.showMenu ? 'flex' : 'hidden'"
          class="flex-col mt-8 space-y-4 md:flex md:space-y-0 md:flex-row md:items-center md:space-x-10 md:mt-0">
          <li v-if="!isExcludedPage" class="text-black-400 hover:text-indigo-400 text-center">
            <div @click="enquiryActivate" class="lg:hidden flex item-center justify-center">
              <button class="block py-2 pl-3 pr-4 rounded lg:p-0 border rounded-xl">
                Enquire Now
              </button>
            </div>
          </li>
          <li v-if="!isExcludedPage" class="text-black-400 lg:hidden hover:text-indigo-400">
            <a @click="handleRedirect"
              class="text-lg font-semibold text-white bg-[#81C8DC] p-2 pr-8 pl-8 rounded-xl">Apply Now</a>
          </li>
        </ul>
      </nav>
      <!-- <div v-if="is_widget" class>
        <popupView
          @closeWidget="is_widget = false"
          :widget_prop_id="this.enquire_widget"
        />
      </div> -->
    </div>
    <!-- enquire-widget -->
    <EnquiryWidget v-if="showWidget" @close="showWidget = false" />
    <!-- enquire-widget -->
  </section>
</template>

<script>
import EnquiryWidget from "../components/EnquireWidget.vue";

export default {
  components: { EnquiryWidget },

  data() {
    return {
      is_widget: false,
      showMenu: false,
      showWidget: false,
      openTab: 1,
      activeSection: 'masters',
      openProgram: null,
      isDropdownOpen: false
    };
  },

  created() {
    setTimeout(() => {
      this.is_widget = true;
    }, 2000);

  },

  watch: {
    isDropdownOpen(newVal) {
      if (newVal) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    }
  },

  beforeUnmount() {
    // Ensure scroll is restored if component unmounts
    document.body.classList.remove('overflow-hidden');
  },

  computed: {
    isExcludedPage() {
      const excludedPaths = ["online-bcom-advanced-finance-and-accounting", "online-bcom-corporate-accounting"];
      return excludedPaths.some((path) => this.$route.path.includes(path));
    }
  },

  methods: {
    toggleTabs(tabNumber) {
      this.openTab = tabNumber;
    },
    toggleProgram(program) {
      this.openProgram = this.openProgram === program ? null : program;
    },
    enquiryActivate() {
      const url = window.location.href;
      const landingPageStatus = url.includes("src=landing")
      const targetUrlWithSrc = "https://gcc.onlineyenepoya.com/apply-now.php";

      if (landingPageStatus) {
        window.open(targetUrlWithSrc, "_blank");
      }
      else {
        this.showWidget = true
      }

    },
    handleRedirect() {
      const url = window.location.href;
      const targetUrlWithSrc = "https://gcc.onlineyenepoya.com/apply-now.php";
      const targetUrlWithoutSrc = "https://apply.onlineyenepoya.com/";

      const finalUrl = url.includes("src=landing") ? targetUrlWithSrc : targetUrlWithoutSrc;

      // Open in new window/tab
      window.open(finalUrl, "_blank");
    }
  }
};
</script>


<style>
.scroll-text {
  color: #001c50;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
}

@media (max-width: 480px) {
  .scroll-text {
    color: #001c50;
    font-size: small;
    font-weight: bolder;
    white-space: nowrap;
    overflow: hidden;
  }
}

.scroll-text {
  /* animation properties */
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);

  -moz-animation: my-animation 10s linear infinite;
  -webkit-animation: my-animation 10s linear infinite;
  animation: my-animation 30s linear infinite;
}

.scroll-text:hover {
  -webkit-animation-play-state: paused;
  -moz-animation-play-state: paused;
  -o-animation-play-state: paused;
  animation-play-state: paused;
}

/* for Firefox */
@-moz-keyframes my-animation {
  from {
    -moz-transform: translateX(100%);
  }

  to {
    -moz-transform: translateX(-100%);
  }
}

/* for Chrome */
@-webkit-keyframes my-animation {
  from {
    -webkit-transform: translateX(100%);
  }

  to {
    -webkit-transform: translateX(-100%);
  }
}

@keyframes my-animation {
  from {
    -moz-transform: translateX(100%);
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }

  to {
    -moz-transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
</style>
